import { LOCAL_STORAGE_KEY } from "../../../config";
import { flowClientSideKycSignatureMultiLender } from "../../flowClientSideKycSignatureMultiLender";
import { flowDisabledLoan } from "../../flowDisabledLoan";
import { flowWelcomeAndTerms } from "../../flowWelcomeAndTerms";
import { DISABLED_LOAN_STATUS } from "../constants/DisabledLoanStatus";

export const astaraFlow = [
  {
    ...flowDisabledLoan,
    condition: (processState) => {
      return DISABLED_LOAN_STATUS.includes(processState?.loan?.status);
    },
  },
  {
    ...flowWelcomeAndTerms,
    condition: (processState) => {
      // return true;
      if (
        localStorage.getItem(LOCAL_STORAGE_KEY.LOAN_ID) === processState.loan.id
      ) {
        return false;
      }
      return !processState.participant.onboardingDetails.has_digital_footprint;
    },
  },
  {
    ...flowClientSideKycSignatureMultiLender,
    condition: (processState) => {
      return true;
      // return (
      //   processState?.participant?.onboardingDetails.fulfilled_by ===
      //   ONBOARDING_FULFILLED_BY_TYPES.CLIENT_SIDE_KYC_SIGNATURE
      // );
    },
  },
];
